<script setup lang="ts">
import Button from "~/components/ui/button/Button.vue";
import { cn } from "~/lib/utils";

const props = defineProps({
  selectedAttribute: {
    type: String,
  },
});

const documentId = inject("documentId") as any;
const selfAssessmentStore = useDocumentSelfAssessmentStore(documentId);
const { allSteps } = storeToRefs(selfAssessmentStore);

const dressUpSteps = computed(() => {
  return allSteps.value.filter((step) => {
    return step.validationAttributes?.underline == true;
  });
});

const selectedStep = computed(() => {
  if (props.selectedAttribute == undefined) return undefined;

  return allSteps.value.find((step) => {
    return step.criteriaAttribute.attribute === props.selectedAttribute;
  });
});

const emit = defineEmits(["select", "clear"]);
</script>

<template>
  <div class="p-1.5 flex flex-col gap-0.5">
    <div class="text-xs font-semibold text-muted-foreground px-2 py-1">
      Select Type
    </div>
    <Button
      v-for="step in dressUpSteps"
      :key="step.identifier"
      variant="ghost"
      class="flex flex-row items-center justify-start h-auto py-1.5 px-2 text-xs font-normal w-full hover:bg-accent hover:text-accent-foreground rounded"
      :class="{
        'bg-accent text-accent-foreground':
          selectedStep?.identifier === step.identifier,
      }"
      @click="emit('select', step)"
    >
      <BaseIconCheck
        :class="
          cn(
            'mr-1 h-3 w-3',
            selectedStep?.identifier === step.identifier
              ? 'opacity-100'
              : 'opacity-0'
          )
        "
      />
      {{ step.label }}
    </Button>
    <div v-if="selectedStep">
      <Button
        variant="ghost"
        class="flex flex-row items-center justify-start h-auto py-1.5 px-2  font-normal w-full text-danger-default hover:bg-danger/10 hover:text-danger-default"
        @click="emit('clear')"
      >
        <BaseIconDelete class="mr-1 text-danger-default" />

        <span class="text-xs">
          clear
        </span>
      </Button>
    </div>
  </div>
</template>

<style scoped></style>
